/* eslint-disable no-restricted-syntax, arrow-body-style */

import { mapActions, mapGetters } from 'vuex';
import { dateToString, toCents } from '@/utils/helpers';
import moment from 'moment';
import { MODALS } from '@/components/app/app-modals/app-modals';
import smallModal from '@/components/generics/modal/small/small.vue';
import loaderMixin from '@/mixins/loader';
import { isMarketSingle } from '@/utils/helpers';

export const CANCEL_ORDER_MODE = {
  ALL: 'all',
  SINGLE: 'single',
  NONE: 'none',
};

export default {
  mixins: [loaderMixin],
  components: {
    smallModal,
  },
  props: {
    slim: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: Object,
      required: true,
    },
    market: {
      type: Object,
      required: true,
    },
    buyOffers: {
      type: Array,
      required: true,
      default: [],
    },
    sellOffers: {
      type: Array,
      required: true,
      default: [],
    },
  },
  data() {
    return {
      CANCEL_ORDER_MODE,
      showAll: false,
      showAllCut: 5,
      deleteAllMode: false,
      deleteOfferId: null,
      showMenu: false,
      cancelModalMode: CANCEL_ORDER_MODE.NONE, // 'all', 'single'
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isCancelOrdersEnabled']),
    ...mapGetters('user', ['isLoggedIn']),
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    imageUrl() {
      return this.contract.contractImageSmallUrl || this.contract.contractImageUrl;
    },
    contractImageStyleModifiers() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
    offersToDelete() {
      if (this.deleteAllMode) {
        return this.offers;
      }
      return this.offers.filter(o => o.offerId === this.deleteOfferId);
    },
    title() {
      return 'Orders';
    },
    showCancelModal() {
      return this.cancelModalMode !== CANCEL_ORDER_MODE.NONE;
    },
    classModifiers() {
      return {
        'order-book-all-offers-sushi': true,
        'order-book-all-offers-sushi--delete-all': this.deleteAllMode,
      };
    },
    tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--slim': this.slim,
      };
    },
    offers() {
      const buyOffers = this.buyOffers.map((o) => {
        return {
          ...o,
          pricePerShare: toCents(o.pricePerShare),
        };
      });
      const sellOffers = this.sellOffers.map((o) => {
        return {
          ...o,
          pricePerShare: toCents(o.pricePerShare),
        };
      });
      buyOffers.sort((prev, next) => {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        let result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return -result;
      });
      sellOffers.sort((prev, next) => {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        let result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return result;
      });
      return [...buyOffers, ...sellOffers];
    },
    showAllItemsNotice() {
      return this.offers.length > this.showAllCut;
    },
    itemsToDisplay() {
      return this.showAll ? this.offers : this.offers.slice(0, this.showAllCut)
    },
    showProcessedNotice() {
      for (const item of this.offers) {
        if (!item.isProcessed) return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('market', ['getMarket']),
    ...mapActions('trade', [
      'cancelOffer', 'cancelAllOffers', 'getContractOffers', 'getOrderBook',
      'setTradeOptions',
    ]),
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    getDate(item) {
      const v = dateToString(item.dateCreated).split(' ');
      return v[0];
    },
    getDateFull(item) {
      return dateToString(item.dateCreated);
    },
    onClickInner() {

    },
    onClickOutside() {
      this.showMenu = false;
    },
    rowModifiers(item) {
      return {
        'order-book-sushi__row': true,
        'order-book-all-offers-sushi__row--to-cancel': (item.offerId === this.deleteOfferId) || this.deleteAllMode,
      };
    },
    rowTitle(item) {
      return `Created ${moment(item.dateCreated).format('MM/DD/YYYY h:mm a')} ET - Original Quantity: ${item.quantity}`;
    },
    rowClicked(item) {
      if (!this.isLayoutMobile) return;
      this.setCurrentSmallPopup(MODALS.SMALL_OFFER_INFO);
      this.setCurrentPopupOptions({
        title: this.rowTitle(item),
      });
    },
    offerInfoDisplay(item) {
      switch (item.tradeType) {
        case 0: return 'Buy NO';
        case 1: return 'Buy YES';
        case 2: return 'Sell NO';
        case 3: return 'Sell YES';
        default: return '';
      }
    },
    offerFullInfoDisplay(item) {
      const quantity = item.remainingQuantity.toLocaleString();
      const price = `${item.pricePerShare}&cent;`;
      switch (item.tradeType) {
        case 0: return `Buy ${quantity} NO at Max ${price}`;
        case 1: return `Buy ${quantity} YES at Max ${price}`;
        case 2: return `Sell ${quantity} NO at Min ${price}`;
        case 3: return `Sell ${quantity} YES at Min ${price}`;
        default: return '';
      }
    },
    deleteClicked(offerId) {
      this.cancelClicked();
      this.deleteOfferId = offerId;
      this.cancelModalMode = CANCEL_ORDER_MODE.SINGLE;
    },
    confirmDeleteClicked(offerId) {
      if (!this.isCancelOrdersEnabled) {
        // this.setCurrentSmallPopup(MODALS.SMALL_PROCESS_ERROR);
        this.setCurrentPopupOptions({ message: 'The site is in Maintenance so we are unable to cancel your order at this time. Please try again later.' });
      } else {
        this.loaderAdd(document.body);
        this.cancelOffer(offerId).then(
          () => {
            this.setSuccessSideNotification('Your order has been removed.');
            this.getContractOffers(this.contract.contractId);
            this.cancelClicked();
            this.$emit('offerCanceled');
          },
        ).catch(() => this.cancelClicked());
      }
    },
    deleteAllClicked() {
      this.cancelClicked();
      this.deleteAllMode = true;
      this.showMenu = false;
      this.cancelModalMode = CANCEL_ORDER_MODE.ALL;
    },
    confirmDeleteAllClicked() {
      if (!this.isCancelOrdersEnabled) {
        // this.setCurrentSmallPopup(MODALS.SMALL_PROCESS_ERROR);
        this.setCurrentPopupOptions({ message: 'The site is in Maintenance so we are unable to cancel your order at this time. Please try again later.' });
      } else {
        const payload = {
          contractId: this.contract.contractId,
          // offerType: this.operationType,
        };
        this.loaderAdd(document.body);
        this.cancelAllOffers(payload).then(
          () => {
            this.setSuccessSideNotification('Your orders have been removed.');
            this.getContractOffers(this.contract.contractId);
            this.cancelClicked();
            this.$emit('offerCanceled');
          },
        ).catch(() => this.cancelClicked());
      }
    },
    cancelClicked() {
      this.cancelModalMode = CANCEL_ORDER_MODE.NONE;
      this.showMenu = false;
      this.deleteAllMode = false;
      this.deleteOfferId = null;
      this.loaderRemove(document.body);
    },
  },
  created() {
    this.cancelClicked();
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/order-book-sushi/order-book-all-offers-sushi/order-book-all-offers-sushi.js